import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { MaterialModal, ElevatedButton } from 'components/layout'

export default class FileUploadModal extends Component {
  static propTypes = {
    colorClass: PropTypes.string,
    modalId: PropTypes.string,
    onClose: PropTypes.func,
    onConfirm: PropTypes.func
  }

  render() {
    const { colorClass, modalId } = this.props

    return (
      <MaterialModal.Body
        id={modalId}
        colorClass={colorClass}
        title="File removal"
        titleKey="moduleTitle.file_removal"
        narrow
      >
        <MaterialModal.Content minimal>
          <div className="base-margin">
            <div className="row">
              <div className="col-xs-6">
                <ElevatedButton
                  onClick={this.props.onClose}
                  intlKey="button.close"
                  uppercase
                >
                  Close
                </ElevatedButton>
              </div>
              <div className="col-xs-6 text--right">
                <ElevatedButton
                  onClick={() => this.props.onConfirm()}
                  intlKey="button.delete"
                  uppercase
                  negative
                  inline
                >
                  Delete
                </ElevatedButton>
              </div>
            </div>
          </div>
        </MaterialModal.Content>
      </MaterialModal.Body>
    )
  }
}
